import { jsxs as r, jsx as l } from "react/jsx-runtime";
const c = (o) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...o,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M47.2 31.54c-4.06-4.06-9.46-6.3-15.21-6.3s-11.14 2.24-15.21 6.3l2.83 2.83c3.31-3.31 7.7-5.13 12.38-5.13 4.68 0 9.07 1.82 12.38 5.13l2.83-2.83ZM40.66 38.09c-2.32-2.31-5.39-3.59-8.66-3.59-3.27 0-6.35 1.27-8.66 3.59l2.83 2.83A8.193 8.193 0 0 1 32 38.5c2.2 0 4.27.86 5.83 2.41l2.83-2.82ZM33.618 43.055l-4.424 1.185 1.186 4.424 4.424-1.186-1.186-4.423Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M57.98 52.93V20.01l-26-14-26 14v34c0 2.21 1.79 4 4 4h45.07l-1.07-4h-44V22.4l22-11.85 22 11.85V54l4-1.07Z"
        }
      )
    ]
  }
);
export {
  c as SmartHome
};
